import React from "react"
import { graphql } from "gatsby"
import { GatsbyImage, getImage } from "gatsby-plugin-image"
import Layout from "../components/layout"
import Seo from "../components/seo"
import Sidebar from "../components/Sidebar"

const ProductTemplate = ({ data }) => {
    const { frontmatter } = data.markdownRemark
    return (
        <Layout>
            <div className="max-w-7xl mx-auto px-4">
                <div className="md:py-20 py-14 lg:px-14 px-4">
                    <h2 className="md:text-4xl text-2xl text-gray-600 font-bold mb-0">{frontmatter.title}</h2>
                </div>
                <div className="bg-white flex gap-6 md:flex-row flex-col lg:px-14 px-4 py-10">
                    <div className="md:w-2/3 w-full">
                        <p className="text-sm text-neutral-500">May 27, 2016</p>
                        <div className="text-center">
                            <GatsbyImage image={getImage(frontmatter.featuredimage)} alt="" />
                        </div>
                    </div>
                    <div className="md:w-1/3 w-full">
                        <Sidebar />
                    </div>
                </div>
            </div>
        </Layout>
    )
}

export const Head = (props) => <Seo title={` ${props.data.markdownRemark.frontmatter.meta.seoTitle}`} description={`props.data.markdownRemark.frontmatter.meta.seoDescription`} path={props.location.pathname} />

export const pageQuery = graphql`
  query ProductByID($id: String!) {
    markdownRemark(id: { eq: $id }) {
        frontmatter {
            title
            featuredimage {
                childImageSharp {
                  gatsbyImageData(layout: CONSTRAINED)
                }
              }

            meta {
                seoTitle
                seoDescription
              }
        }
    }
  }
`;
export default ProductTemplate